import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useDuration from '@/composables/useDuration'
  import useCourse from '@/composables/useCourse'
  import { CourseModule } from '@/store/modules/course'
  import useI18n from '@/composables/useI18n'
  import type { PropType } from 'vue'
  import type { CourseItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseModuleDuration',
  props: {
    course: {
      type: Object as PropType<CourseItem | null>,
      required: true,
    },
    numberOfModules: {
      type: Number,
    },
  },
  setup(__props) {

const props = __props;

  

  const { translateString } = useI18n()
  const { durationIcon, moduleIcon, eclipseLoaderIcon } = useIcons()
  const { formatDurationToHHMM } = useDuration()
  const { guidedQuizDuration } = useCourse()

  const courseDuration = computed(() => {
    const moduleDuration =
      CourseModule.coursesModuleMap[props.course?.id || '']?.reduce((acc, mod) => {
        acc += guidedQuizDuration.value(mod.guidedQuiz?.numberOfQuestions || 0)
        return acc
      }, 0) || 0
    return formatDurationToHHMM((props.course?.duration || 0) + moduleDuration)
  })

  const numberOfModulesText = computed(() => {
    return props.numberOfModules === 1 ? translateString('courses.module') : translateString('courses.modules')
  })

return { __sfc: true,props, translateString, durationIcon, moduleIcon, eclipseLoaderIcon, formatDurationToHHMM, guidedQuizDuration, courseDuration, numberOfModulesText, computed, SVGRenderer, useIcons, useDuration, useCourse, CourseModule, useI18n }
}

})